<div class="w-full h-full py-11 px-5 flex flex-wrap justify-center max-w-[500px] overflow-auto">

    <ng-container *ngIf="alertService.config.type === 'confirmation-icon'">

        <div class="w-full flex justify-center">
            <img class="w-24" src="assets/icons/error.svg" alt="">
        </div>

        <h3 class="anton-regular text-5xl mt-6 text-center">{{ alertService.config.title }}</h3>

        <p class="raleway-400 text-lg mt-5 text-center" [innerHTML]="alertService.config.message"></p>

        <div class="w-full flex justify-center gap-3 mt-5">
            <button *ngIf="alertService.config.actions.cancel"
                class="raleway-600 text-xl bg-mj-gris-4 text-white py-4 px-10 rounded-full shadow-md"
                (click)="onCancel()">
                {{ alertService.config.actions.cancel.label }}
            </button>

            <button class="raleway-600 text-xl bg-mj-azul-4 text-white py-4 px-10 rounded-full shadow-md"
                (click)="onConfirm()">
                {{ alertService.config.actions.confirm.label }}
            </button>
        </div>

    </ng-container>

    <ng-container *ngIf="alertService.config.type === 'deprecated'">

        <div class="w-full flex justify-center">
            <img class="w-24" src="assets/icons/error.svg" alt="">
        </div>

        <h3 class="anton-regular text-5xl mt-6">{{ alertService.config.title }}</h3>
        <p class="raleway-400 text-lg mt-5">{{ alertService.config.message }}</p>

        <button class="raleway-600 text-xl mt-5 bg-mj-azul-4 text-white py-4 px-10 rounded-full shadow-md"
            (click)="onConfirm()">
            {{ alertService.config.actions?.confirm?.label }}
        </button>

    </ng-container>

    <ng-container *ngIf="alertService.config.type === 'dialog'">

        <div class="w-full flex justify-end absolute top-3 right-3">
            <button (click)="onCancel()">
                <mat-icon class="text-secondary" [svgIcon]="'mdi:close-thick'"></mat-icon>
            </button>
        </div>

        <h3 class="anton-regular text-5xl mt-6 text-center">{{ alertService.config.title }}</h3>
        
        <div class="max-h-64 overflow-y-auto px-2 mt-5">
            <p class="raleway-700 text-2xl text-center break-words" [innerHTML]="alertService.config.message"></p>
        </div>

        <a *ngIf="alertService.config.navigate?.show" [routerLink]="[alertService.config.navigate.url]"
            class="raleway-600 text-xl mt-5 bg-mj-azul-4 text-white py-4 px-10 rounded-full shadow-md"
            (click)="onCancel()">
            {{ alertService.config.actions.confirm.label }}
        </a>

        <button *ngIf="!alertService.config.navigate?.show"
            class="raleway-600 text-xl mt-5 bg-mj-azul-4 text-white py-4 px-10 rounded-full shadow-md"
            (click)="onConfirm()">
            {{ alertService.config.actions.confirm.label }}
        </button>

    </ng-container>

</div>